import { Action, Reducer } from 'redux';
import { AppThunkAction } from '.';
import { map, forEach, filter, orderBy } from 'lodash';
import update from 'immutability-helper';
import { AccountShortInformation, AccountService } from '../models/AccountModels';
import { NotificationTypeEnum, NotificationToast } from '../models/NotificationModels'
import { ToastNotificationManager } from '../infrastructure/ToastNotificationManager'
import { ApiResponseHelper } from '../infrastructure/utils/ApiResponseHelper'
import { AppealRequests } from '../apiRequests/AppealRequests';
import { AppealReferanceRequests } from '../apiRequests/AppealReferanceRequests';





export interface AppealListState {
    isLoading: boolean;
    appeals: any[];

}


export interface InitAppealListAction {
    type: 'INIT_APPEAL_LIST';
}

export interface UnMountAppealListAction {
    type: 'UNMOUNT_APPEAL_LIST';
}

export interface RequestAppealListAction {
    type: 'REQUEST_APPEAL_LIST';
}

export interface ReceiveAppealListAction  {
    type: 'RECEIVE_APPEAL_LIST';
    appeals: any[];

}

export interface ErrorAppealListAction  {
    type: 'ERROR_APPEAL_LIST';
}






const apiAppealRequest = new AppealRequests();
const apiAppealReferanceReques = new AppealReferanceRequests();


type KnownAction = InitAppealListAction | UnMountAppealListAction |
    RequestAppealListAction | ReceiveAppealListAction | ErrorAppealListAction ;


export const actionCreators = {

    InitAppealListAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        apiAppealRequest.Init();
        apiAppealReferanceReques.Init();

        dispatch({
            type: 'INIT_APPEAL_LIST',
        });

    },
    UnMountAppealListAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {


        dispatch({
            type: 'UNMOUNT_APPEAL_LIST',
        });

    },

    GetAppealListAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        dispatch({
            type: 'REQUEST_APPEAL_LIST',
        });



      
    }


};


const unloadedState: AppealListState = {
    isLoading: false, appeals: []
};

export const reducer: Reducer<AppealListState> = (state: AppealListState | undefined, incomingAction: Action): AppealListState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'INIT_APPEAL_LIST':
            return {
                ...state,
            };

        case 'UNMOUNT_APPEAL_LIST':
            return {
                ...state,
            };
        case 'REQUEST_APPEAL_LIST':
            return {
                ...state,
                isLoading: true,
            };
        case 'RECEIVE_APPEAL_LIST':
            return {
                ...state,
                isLoading: false,
                appeals: action.appeals,
            }
        case 'ERROR_APPEAL_LIST':
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }

};
